/**
 * Sticky header functionality
 *
 * @package Embark
 * @since   1.0.0
 */

import { els } from './variables';

/**
 * Tracks the current scroll position on the page.
 *
 * @type {Number}
 */
let currentScrollPoint;
let prevScrollPoint = (els.html && els.html.scrollTop) || els.body.scrollTop;

/**
 * The point (in pixels) at which the header class should be toggled.
 *
 * @type {Number}
 */
const headerScrollPoint = els.header.offsetHeight;

/**
 * Toggle the header scrolled class.
 */
function maybeToggleScrolledClass() {
	/**
	 * Update the current scroll position.
	 *
	 * @type {Number}
	 */
	currentScrollPoint = (els.html && els.html.scrollTop) || els.body.scrollTop;

	/**
	 * Check scroll status and toggle .scrolled accordingly.
	 */
	if (currentScrollPoint >= headerScrollPoint) {
		els.header.classList.add('scrolled');
	} else if( currentScrollPoint <= 0 && ! els.html.classList.contains('html--menu-open') ) {
		els.header.classList.remove('scrolled');
	}

	if (prevScrollPoint > currentScrollPoint) {
		els.header.classList.add('scrolled-up');
		els.header.classList.remove('scrolled-down');
	} else {
		els.header.classList.add('scrolled-down');
		els.header.classList.remove('scrolled-up');
	}

	prevScrollPoint = currentScrollPoint;
}

window.addEventListener('scroll', maybeToggleScrolledClass);
window.addEventListener('load', maybeToggleScrolledClass);
